<body class="body-form-signin login-bg"
  [style]="whitelabel ? 'background-image: url(' + whitelabelURL + whitelabel + '/login.webp);' : ''">

  <main class="form-signout" style="max-width: 400px">
    <form class="form-shadow container g-0">
      <div class="row p-0 m-0 g-0">
        <div class="p-4">
          <div class="text-center mb-3">
            <a href="https://cubos.com" target="_blank" *ngIf="!whitelabel || whitelabel == 'cubos'">
              <img class="my-4" src="assets/images/cubos_connect_logo_4c.svg" alt="CUBOS.Connect" width="272">
            </a>
            <a *ngIf="whitelabel">
              <img class="logo mb-4" [src]="whitelabelURL + whitelabel + '/logo.png'" [alt]="whitelabel">
            </a>
            <div class="mb-2 mt-2">
              <h4 class="mt-md-1 ml-md-0 ml-4 text-center" i18n="@@LogoutSuccess">
                Auf Wiedersehen!</h4>
              <h5 i18n="@@LogoutSuccessText">Sie haben sich erfolgreich abgemeldet.</h5>
            </div>
          </div>
          <div class="mt-2 text-center mb-3">
            <br />
            <button [routerLink]="['/auth/login']" id="backtologin" class="w-100 w-sm-75 w-md-50 btn btn-yellow"
              i18n="@@BackToLoginButton">Zurück zur Anmeldung</button>
          </div>
          <p class="mt-2 mb-3 text-center text-muted"><a href="https://www.cubos.com" target="_blank"
              style="text-decoration: none; color: #6c757d;">© {{currentYearLong()}} CUBOS Service GmbH</a></p>
        </div>
      </div>
    </form>

  </main>
</body>
